import React, {Component} from 'react';
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";

export default class CountOnline extends Component {

    constructor() {
        super();
        this.isChatLoaded = false;
    }
    componentDidUpdate() {
        if(!this.props.counterUrl || this.isChatLoaded) {
            return;
        }

        this.isChatLoaded = true;
        const script = document.createElement("script");
        script.src = this.props.counterUrl ;
        script.async = true;
        document.body.appendChild(script);
    }

    render() {

        if(!this.props.counterUrl) {
            return (<CircularProgress/>);
        }

        return (
            <Typography id="online-count" variant="subtitle2" component="h6">
                Online: <span id={"webinar-event-counter-"+this.props.eventId}>0</span>
            </Typography>
        )
    }
}
